import { apiCall } from './api';
import { ReviewResponseSchema } from './schemas/review';
import type { ReviewResponse, SubmitReviewInput } from './schemas/review';

export async function submitReview(
  accessToken: string,
  body: SubmitReviewInput,
): Promise<ReviewResponse> {
  const res = await apiCall<unknown>('/reviews', {
    accessToken,
    method: 'POST',
    body,
  });
  return ReviewResponseSchema.parse(res.data);
}

export async function fetchTutorReviews(
  accessToken: string,
  tutorId: string,
): Promise<ReviewResponse[]> {
  const res = await apiCall<unknown[]>(`/tutors/${tutorId}/reviews`, {
    accessToken,
  });
  return (res.data ?? []).map((r) => ReviewResponseSchema.parse(r));
}
